import React from "react";
import OrderTile from "../OrderTile";

const OrderComponent = (props) => {
  const { styles, ordersList } = props;
  return (
    <>
      {ordersList.map((order) => (
        <OrderTile
          styles={styles}
          key={order.id}
          order={order}
          activeTab={props.activeTab}
          setActiveOrder={props.setActiveOrder}
        />
      ))}
    </>
  );
};

export default OrderComponent;
